export default __webpack_public_path__ + "static/media/cliente2.f72b038f.jpg";